import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.NODE_ENV==='development'? 
  'http://localhost:4000/':
  'https://tstatsapi.stats-insight.com/',
  withCredentials: true
})

export const api_authUserLogin = async (payload) => {
  console.log('Get User Login')
  try {
    const { data } = await instance.post('usr/login', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    console.log(err)
    return { status: 'error', message: err.message }
  }
}

export const api_getFilterResult = async (payload) => {
  console.log('Get Filter Result')
  try {
    const { data } = await instance.post('ballsStat/getFilmroomResult', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getPlayerRoster = async () => {
  console.log('Get Player Roster')
  try {
    const { data } = await instance.get('/ballsStat/getPlayerRoster')
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getVideoSignedURL = async (payload) => {
  console.log('Get Video URL')
  try {
    const { data: { url } } = await instance.post('/video/getVideoURL', payload)
    // console.log("url:", url)
    return url
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}